import * as types from './constants';

// Get Refer Link
export const getReferralLinkRequest = data => (
  { type: types.GET_REFERRALS_LINK_REQUEST, payload: data }
);

export const getReferralLinkDone = data => (
  { type: types.GET_REFERRALS_LINK_DONE, payload: data }
);

export const getReferralLinkFailed = errors => (
  { type: types.GET_REFERRALS_LINK_FAILED, payload: errors }
);

// Create Refer Link
export const createReferralLinkRequest = data => (
  { type: types.CREATE_REFERRALS_LINK_REQUEST, payload: data }
);

export const createReferralLinkDone = data => (
  { type: types.CREATE_REFERRALS_LINK_DONE, payload: data }
);

export const createReferralLinkFailed = errors => (
  { type: types.CREATE_REFERRALS_LINK_FAILED, payload: errors }
);

export const createReferralLinkReset = () => (
  { type: types.CREATE_REFERRALS_LINK_RESET }
);